import React, { useState } from 'react';
interface PricingOption {
  id: string;
  emoji: string;
  title: string;
  description: string;
  originalPrice: string;
  price: string;
  ctaText: string;
  ctaHref: string;
  isFeatured?: boolean;
  savings?: string;
}
const options: PricingOption[] = [{
  id: 'primaria',
  emoji: '📘',
  title: 'EDUCACIÓN PRIMARIA / BÁSICA',
  description: '6 tomos + 120 clases planificadas + 6 bonos estratégicos',
  originalPrice: 'USD 35.00',
  price: 'USD 11.90',
  ctaText: '→ QUIERO PRIMARIA / BÁSICA',
  ctaHref: 'https://docentes2.edulabs.online/cart/43186090737782:1'
}, {
  id: 'completo',
  emoji: '🏆',
  title: 'PACK COMPLETO',
  description: '12 tomos + 240 clases planificadas + 6 bonos estratégicos',
  originalPrice: 'USD 25.80',
  price: 'USD 19.90',
  ctaText: '→ QUIERO EL PACK COMPLETO',
  ctaHref: 'https://docentes2.edulabs.online/cart/43111263240310:1',
  isFeatured: true,
  savings: 'AHORRAS USD 5.90'
}, {
  id: 'secundaria',
  emoji: '📗',
  title: 'EDUCACIÓN SECUNDARIA / MEDIA',
  description: '6 tomos + 120 clases planificadas + 6 bonos estratégicos',
  originalPrice: 'USD 35.00',
  price: 'USD 13.90',
  ctaText: '→ QUIERO SECUNDARIA / MEDIA',
  ctaHref: 'https://docentes2.edulabs.online/cart/43186272534646:1'
}];
export function PricingSection() {
  const [selected, setSelected] = useState('completo');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="pricing" className="w-full bg-[#111111] py-4 sm:py-8 px-4" data-id="element-155">
      <div className="max-w-xl mx-auto" data-id="element-156">
        {/* Header */}
        <h2 className="text-2xl sm:text-4xl font-black text-white text-center mb-0.5 sm:mb-1" data-id="element-157">
          Elige tu <span className="text-[#FFD700]" data-id="element-158">MegaPack:</span>
        </h2>
        <p className="text-gray-300 text-center text-xs sm:text-base mb-3 sm:mb-4" data-id="element-159">
          Todas las opciones incluyen los 6 bonos estratégicos
        </p>

        {/* Options */}
        <div className="space-y-1.5 sm:space-y-2 mb-3 sm:mb-4" data-id="element-160">
          {options.map(option => {
          const isSelected = selected === option.id;
          const isFeatured = option.isFeatured;
          return <button key={option.id} onClick={() => setSelected(option.id)} className={`w-full text-left rounded-xl sm:rounded-2xl p-2.5 sm:p-4 transition-all ${isFeatured && isSelected ? 'border-2 border-[#FFD700] bg-[#0d0d00] shadow-[0_0_30px_rgba(255,215,0,0.15)]' : isFeatured ? 'border-2 border-[#FFD700]/50 bg-[#0d0d00]' : isSelected ? 'border-2 border-[#FFD700] bg-[#0a0a0a]' : 'border border-white/10 bg-[#0a0a0a]'}`} data-id="element-161">
                <div className="flex items-center gap-2 sm:gap-3" data-id="element-162">
                  {/* Radio */}
                  <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${isSelected ? 'border-[#FFD700]' : 'border-white/30'}`} data-id="element-163">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-[#FFD700]" data-id="element-164" />}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0" data-id="element-165">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-166">
                      <span className="text-lg" data-id="element-167">{option.emoji}</span>
                      <span className="text-white font-black text-base sm:text-lg" data-id="element-168">
                        {option.title}
                      </span>
                    </div>

                    {/* Badges */}
                    {isFeatured && <div className="flex items-center gap-2 mt-1.5 sm:mt-2 flex-wrap" data-id="element-169">
                        <span className="bg-[#FFD700] text-black text-[11px] sm:text-xs font-black px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full" data-id="element-170">
                          ⭐ MÁS ELEGIDO
                        </span>
                        {option.savings && <span className="bg-[#FFD700]/20 text-[#FFD700] text-[11px] sm:text-xs font-bold px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full border border-[#FFD700]/40" data-id="element-171">
                            {option.savings}
                          </span>}
                      </div>}

                    <p className="text-gray-400 text-sm mt-1" data-id="element-172">
                      {option.description}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="text-right flex-shrink-0" data-id="element-173">
                    <div className="text-gray-500 line-through text-xs sm:text-sm" data-id="element-174">
                      {option.originalPrice}
                    </div>
                    <div className={`font-black text-2xl sm:text-3xl ${isFeatured ? 'text-[#FFD700]' : 'text-white'}`} data-id="element-175">
                      {option.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* CTA Button */}
        <a href={selectedOption.ctaHref} className="btn-gold-pulse block w-full text-center bg-[#FFD700] text-black font-black text-base sm:text-xl py-3.5 sm:py-4 rounded-xl sm:rounded-2xl hover:bg-yellow-300 transition-colors" data-id="element-176">
          {selectedOption.ctaText}
        </a>

        {/* Subtitle under CTA */}
        <p className="text-gray-400 text-xs text-center mt-2 italic leading-relaxed" data-id="element-177">
          El precio es en dólares estadounidenses (USD). El cobro se realiza
          automáticamente en la moneda de tu país al tipo de cambio del momento.
          Pagas en pesos mexicanos, euros, pesos colombianos, soles peruanos,
          pesos chilenos, bolívares, quetzales, lempiras, colones, balboas,
          córdobas o cualquier otra moneda local según tu país de origen.
        </p>

        {/* Trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 text-xs sm:text-sm text-gray-300 mt-3 sm:mt-4 bg-[#0a0a0a] border border-[#FFD700]/20 rounded-xl py-2.5 sm:py-3 px-4 sm:px-6" data-id="element-178">
          <span data-id="element-179">🔒 Pago seguro</span>
          <span data-id="element-180">⚡ Acceso en 5 min</span>
          <span data-id="element-181">🛡️ Garantía 7 días</span>
        </div>
      </div>
    </section>;
}